module.exports = "<img ng-src=\"{{$ctrl.iconSrc}}\" />";


//////////////////
// WEBPACK FOOTER
// ./modules/billing/components/billing-icon-product/billingIconProduct.component.html
// module id = 465
// module chunks = 0